export default __webpack_public_path__ + "static/media/usageAlert.f25143d5.png";